import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { format } from "date-fns";
import dayjs from "dayjs";
import commonLabels from "../../../common/labels/common_en.json";
import ApprovalRuleEntity from "./ApprovalRuleEntity.jsx";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  getSubjectlistByExamId,
  getAnswerKeyList,
  getQuestionSets,
  saveAnswerRules,
  getAllUnApproveRulesListPagination,
  getAllRollNumberList,
  getRulesCalculatedResult,
  generateMarksCalculationPdf,
  getObjectiveStatus,
  getViewResult,
  getObjectiveStatusflag,
  objetiveStatusLockUnlock,
  getAnswerKeySetList,
} from "../../actions/postExaminationProcessObjectiveActions";
import {
  getYearList,
  getAdvertisementlistByYear,
  getResultFlowInfo,
} from "../../../common/actions/commonActions";
import { useRef } from "react";
import html2pdf from "html2pdf.js";
import {
  SET_ALL_ANSWER_KEYDATA,
  SET_OBJECTIVE_STATUS_DATA,
  SET_OBJECTIVE_STATUS_DATA_FLAG,
  SET_PROCESS_LOCK_STATE,
  SET_RULES_CALCULATE_RESULT_DATA,
} from "../../../common/constants/ActionTypes.js";
import { toastr } from "react-redux-toastr";

const ObjectiveMarksCalculation = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const [selectedQuestionSet, setSelectedQuestionSet] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedAdvertisement, setSelectedAdvertisement] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [requestData, setRequestData] = useState([]);
  const [rulesListData, setRulesListData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [answerKeyData, setAnswerKeyData] = useState([]);
  const [rulesDataList, setRulesDataList] = useState([]);
  const [isRuleAlreadySet, setIsRuleAlreadySet] = useState(false);
  const [showCalculateMarks, setShowCalculateMarks] = useState(false);
  const [stepName, setName] = useState("addrule");
  const [addYear, setAddYear] = useState("");
  const [selectedQuestionSetName, setSelectedQuestionSetName] = useState("");
  const [forAllMarks, setForAllMarks] = useState("");
  const [forAllNegativeMarks, setForAllNegativeMarks] = useState("");
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const [flagArray, setFlagArray] = useState([]);
  const [flagArray1, setFlagArray1] = useState([]);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [activeButton, setActiveButton] = useState("");
  const [isMarkCalculated, setIsMarkCalculated] = useState(false);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [triggerTableGeneration, setTriggerTableGeneration] = useState(null);
  const [selectedSubjectType, setSelectedSubjectType] = useState("");
  const date = new Date(); // Your date object here
  const formattedDate = format(date, "MM/dd/yyyy");
  const optionSelectArray = [
    { val: "a", label: "A" },
    { val: "b", label: "B" },
    { val: "c", label: "C" },
    { val: "d", label: "D" },
    { val: "g", label: "G" },
  ];
  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Set",
    "Action",
  ];
  let rowPerPage = 10;
  const length = 50;

  let {
    examList,
    advertisementList,
    questionSetList,
    rollNumberDataList,
    allUnapprovalRulesList,
    subjectList,
    answerKeyDataList,
    unapprovalRulePageNoCounter,
    rulesCalculateResultData,
    objectiveStatusData,
    objectiveStatusDataFlag,
    viewMarksList,
    answerKeySetList
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
    });
    flagArray.length = 0;
    flagArray1.length = 0;
  }, []);

  const handleApprovalUser = (ele) => {
    console.log("REVIEW DATA", ele);
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };
  useEffect(() => {
    if (stepName == "unapproved") {
      dispatch(getAllUnApproveRulesListPagination(listCurrentPage, rowPerPage));
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    dispatch(getYearList());
    setRequestData([]);
  }, []);
  useEffect(() => {
    if (forAllMarks != "" || forAllNegativeMarks != "") {
      let tempData = rulesDataList;

      tempData &&
        tempData.length > 0 &&
        tempData.map((ele, index) => {
          ele &&
            ele.answers &&
            ele.answers.length > 0 &&
            ele.answers.map((elle, index1) => {
              if (forAllMarks) {
                tempData[index].answers[index1].marks = forAllMarks;
              }
              if (forAllNegativeMarks) {
                tempData[index].answers[index1].negativeMarks =
                  forAllNegativeMarks;
              }
            });
        });
      setRulesDataList(tempData);
      setReloadItem(!reloadItem);
      setSaveButtonFlag(false);
    }
  }, [forAllMarks, forAllNegativeMarks]);


  let { yearList, allYearList, processLockState, resultFlowInfo } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let tableCounter_unapproval = unapprovalRulePageNoCounter + 1;

  useEffect(() => {
    if (!rulesDataList || rulesDataList.length === 0) return;
    if (!answerKeySetList || answerKeySetList.length === 0) return;
    if (!answerKeyDataList) return;
    console.log("objectiveStatusDataFlag =>", objectiveStatusDataFlag);
    if (stepName === "addrule") {
      setFlagArray([]);
      if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
        const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
        const flagArrayBeforeInterviewCriteria = [];

        for (let i = 0; i < flagValues.length; i++) {
          if (flagValues[i] === "Answer Key Rule") {
            setFlagArray(flagArrayBeforeInterviewCriteria);
            break;
          } else {
            flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
          }
        }
      }
    } else if (stepName === "marksCalculation") {
      setFlagArray1([]);
      if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
        const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
        const flagArrayBeforeInterviewCriteria = [];

        for (let i = 0; i < flagValues.length; i++) {
          // if (flagValues[i] === "Result") {
          if (flagValues[i] === "Seat Matrix") {
            setFlagArray1(flagArrayBeforeInterviewCriteria);
            break;
          } else {
            flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
          }
        }
        if (flagArrayBeforeInterviewCriteria.some(item => item.flagStatus === false)) {
          toastr.warning(label.UNLOCK_MESSAGE_MARK_CALCULATION);

        }
      }
    }
  }, [objectiveStatusDataFlag]);

  useEffect(() => {
    if (stepName !== "addrule") return;

    if (objectiveStatusDataFlag?.length > 0) {
      const flags = [];

      for (const item of objectiveStatusDataFlag) {
        if (item.flag === "Answer Key Rule") break;
        flags.push(item);
      }

      setFlagArray(flags);
    } else {
      setFlagArray([]);
    }
  }, [objectiveStatusDataFlag, stepName]);

  useEffect(() => {
    if (stepName !== "marksCalculation") return;

    if (objectiveStatusDataFlag?.length > 0) {
      const flags = [];

      for (const item of objectiveStatusDataFlag) {
        if (item.flag === "Seat Matrix") break;
        flags.push(item);
      }

      setFlagArray1(flags);
    } else {
      setFlagArray1([]);
    }
  }, [objectiveStatusDataFlag, stepName]);

  useEffect(() => {
    if (answerKeyDataList && answerKeyDataList.answerKeyRuleDto?.answerKeyRule?.answerKey != null) {
      // let oldRuleList = rulesDataList;
      let oldRuleList = JSON.parse(JSON.stringify(rulesDataList));
      answerKeyDataList.answerKeyRuleDto?.answerKeyRule?.answers &&
        answerKeyDataList.answerKeyRuleDto?.answerKeyRule?.answers?.map((ele, ind) => {
          rulesDataList[ind]?.answers &&
            rulesDataList[ind]?.answers.map((opt, optInd) => {
              if (ele != opt.option && opt.isHidden == false) {
                oldRuleList[ind].answers[optInd].isHidden = true;
              } else if (ele == opt.option && opt.isHidden == true) {
                oldRuleList[ind].answers[optInd].isHidden = false;
              }
              if (optInd == 0) {
                oldRuleList[ind].answers[optInd].isHidden = false;
              }
            });
        });
      setRulesDataList(oldRuleList);
      setReloadItem(!reloadItem);
      setIsRuleAlreadySet(false);
    } else if (answerKeyDataList && answerKeyDataList.answerKeyRuleDto?.answerKeyRule != null) {
      let data = JSON.parse(answerKeyDataList.answerKeyRuleDto?.answerKeyRule?.rules);
      // let oldRuleList = rulesDataList;
      let oldRuleList = JSON.parse(JSON.stringify(rulesDataList));
      data &&
        data.map((ele, ind) => {
          rulesDataList &&
            rulesDataList.map((quesVal, quesInd) => {
              if (quesVal.questionNumber == ele.questionNumber) {
                rulesDataList[quesInd].isWeighted = ele.isWeighted;

                quesVal &&
                  quesVal.answers &&
                  quesVal.answers.length > 0 &&
                  quesVal.answers.map((qansVal, qansInd) => {
                    let isFind =
                      ele &&
                      ele.answers &&
                      ele.answers.length > 0 &&
                      ele.answers.find(
                        (ansVal) => qansVal.option == ansVal.option
                      );
                    if (isFind) {
                      oldRuleList[quesInd].answers[qansInd].isHidden = false;
                    } else {
                      oldRuleList[quesInd].answers[qansInd].isHidden = true;
                    }
                    ele &&
                      ele.answers &&
                      ele.answers.length > 0 &&
                      ele.answers.map((ansVal, ansInd) => {
                        if (qansVal.option == ansVal.option) {
                          oldRuleList[quesInd].answers[qansInd].marks =
                            ansVal.marks;
                          oldRuleList[quesInd].answers[qansInd].negativeMarks =
                            ansVal.negativeMarks;
                        }
                      });
                  });
              }
            });
        });
      setRulesDataList(oldRuleList);
      setReloadItem(!reloadItem);
      setIsRuleAlreadySet(true);
    }
    else if (answerKeyDataList && answerKeyDataList.answerKeyRuleDto?.answerKey != null && answerKeyDataList.answerKeyRuleDto?.answerKey.length !== 0) {
      // let oldRuleList = rulesDataList;
      let oldRuleList = JSON.parse(JSON.stringify(rulesDataList));
      answerKeyDataList.answerKeyRuleDto?.answerKey?.rules && answerKeyDataList.answerKeyRuleDto?.answerKey?.rules?.map((ele, ind) => {
        rulesDataList &&
          rulesDataList.map((quesVal, quesInd) => {
            if (quesVal.questionNumber == ele.questionNumber) {
              rulesDataList[quesInd].isWeighted = ele.isWeighted;
              quesVal &&
                quesVal.answers &&
                quesVal.answers.length > 0 &&
                quesVal.answers.map((qansVal, qansInd) => {
                  let isFind =
                    ele &&
                    ele.answers &&
                    ele.answers.length > 0 &&
                    ele.answers.find(
                      (ansVal) => qansVal.option == ansVal.option
                    );
                  if (isFind) {
                    oldRuleList[quesInd].answers[qansInd].isHidden = false;
                  } else {
                    oldRuleList[quesInd].answers[qansInd].isHidden = true;
                  }
                  ele &&
                    ele.answers &&
                    ele.answers.length > 0 &&
                    ele.answers.map((ansVal, ansInd) => {
                      if (qansVal.option == ansVal.option) {
                        oldRuleList[quesInd].answers[qansInd].marks =
                          ansVal.marks;
                        oldRuleList[quesInd].answers[qansInd].negativeMarks =
                          ansVal.negativeMarks;
                      }
                    });
                });
            }
          });
      });
      setRulesDataList(oldRuleList);
      setReloadItem(!reloadItem);
      setIsRuleAlreadySet(false);
    }

  }, [answerKeyDataList, answerKeySetList]);

  const onRollNumberChange = (e) => {
    let selectedValue = e.target.value;
    selectedValue &&
      dispatch(
        getRulesCalculatedResult(
          selectedExam,
          selectedSubject,
          selectedQuestionSet,
          selectedValue
        )
      );
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else if (stepName == "addrule") {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      if (questionSetList) {
        questionSetList.length = 0;
      }
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
      setFlagArray([]);
      setFlagArray1([]);
    } else if (stepName == "marksCalculation") {
      let selectedValue = ele;
      setAddYear(selectedValue);

      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      if (questionSetList) {
        questionSetList.length = 0;
      }
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
      setFlagArray([]);
      setFlagArray1([]);
    }
  };

  const onSubmit = () => {
    // let oldRuleList = rulesDataList;
    let oldRuleList = JSON.parse(JSON.stringify(rulesDataList));
    rulesDataList &&
      rulesDataList.length > 0 &&
      rulesDataList.map((ele, ind) => {
        let newOptions = [];
        ele &&
          ele.answers &&
          ele.answers.length > 0 &&
          ele.answers.map((ansOnj, indx) => {
            if (ansOnj.isHidden == false) {
              let newObj = {
                option: ansOnj.option,
                marks: ansOnj.marks,
                negativeMarks: ansOnj.negativeMarks,
              };
              newOptions.push(newObj);
            }
          });
        oldRuleList[ind].answers = newOptions;
      });
    oldRuleList &&
      dispatch(
        saveAnswerRules(
          selectedExam,
          selectedSubject,
          selectedQuestionSet,
          oldRuleList,
          examList,
          advertisementList,
          questionSetList,
          subjectList,
          answerKeyDataList,
          isRuleAlreadySet
        )
      );

    if (allYearList) {
      allYearList.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }
    if (subjectList) {
      subjectList.length = 0;
    }
    if (questionSetList) {
      questionSetList.length = 0;
    }
    setSelectedYear("");
    dispatch({
      type: SET_ALL_ANSWER_KEYDATA,
      payload: [],
    });
    dispatch({
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
      payload: [],
    });
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };
  const onSubjectChange = (e) => {
    let selectedValue = e.target.value;
    setSelectedSubject(selectedValue);

    const selectedSubjectObj = subjectList.find(
      (item) => item.id === Number(selectedValue)
    );

    setSelectedSubjectType(selectedSubjectObj?.type || "");

    if (answerKeyDataList.answers) {
      answerKeyDataList.answers.length = 0;
    }

    if (selectedExam && selectedValue) {
      dispatch(
        getObjectiveStatusflag(
          selectedExam,
          setSaveButtonFlag,
          selectedValue
        )
      );
    }

    setSaveButtonFlag(true);
    setRequestData([]);
    setReloadItem(!reloadItem);
  };
  useEffect(() => {
    if (
      selectedAdvertisement &&
      selectedExam &&
      selectedSubject
    ) {
      dispatch(
        getQuestionSets(
          selectedAdvertisement,
          selectedExam,
          selectedSubject
        )
      );
    }
  }, [
    selectedAdvertisement,
    selectedExam,
    selectedSubject
  ]);

  const onQuestionSetChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedQuestionSet(selectedValue);
    setSelectedQuestionSetName(selectedValue);

    dispatch(
      getAnswerKeySetList(
        selectedExam,
        selectedSubject,
        selectedValue
      )
    );

    dispatch(
      getAnswerKeyList(
        selectedExam,
        selectedSubject,
        selectedValue
      )
    );

    setTriggerTableGeneration(selectedValue);

    setRequestData([]);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  useEffect(() => {
    if (
      triggerTableGeneration &&
      answerKeySetList &&
      answerKeySetList.length > 0 &&
      resultFlowInfo
    ) {
      getQuestionCount(triggerTableGeneration);
      setTriggerTableGeneration(null);
    }
  }, [triggerTableGeneration, answerKeySetList, resultFlowInfo]);

  const onCancelButton = () => {
    setSelectedExam("");
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA,
    });
    allYearList.length = 0;
    examList.length = 0;
    if (answerKeyDataList.answers) {
      answerKeyDataList.answers.length = 0;
    }
    subjectList.length = 0;
    questionSetList.length = 0;
    setRequestData([]);
    dispatch({
      payload: [],
      type: SET_ALL_ANSWER_KEYDATA,
    });
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    Promise.resolve()
      .then(() => {

        setSelectedExam(selectedValue);
        dispatch(getObjectiveStatusflag(selectedValue, setSaveButtonFlag));
        subjectList.length = 0;
        questionSetList.length = 0;


        if (answerKeyDataList.answers) {
          answerKeyDataList.answers.length = 0;
        }
        rulesCalculateResultData = "";


        setSaveButtonFlag(true);

        if (selectedAdvertisement && selectedExam && selectedSubject) {
          dispatch(
            getQuestionSets(
              selectedAdvertisement,
              selectedExam,
              selectedSubject
            )
          );
        }
        if (selectedValue) {
          dispatch(getResultFlowInfo(selectedValue));
          return dispatch(getSubjectlistByExamId(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        if (stepName === "marksCalculation" && selectedValue !== "") {
          return dispatch(getObjectiveStatus(selectedExam, selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {

        setRequestData([]);
        setReloadItem((prev) => !prev);
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };

  const getQuestionCount = (setLabel) => {
    let count = 0;

    const postList = resultFlowInfo?.postCriteriaConfigsdTO || [];

    for (let i = 0; i < postList.length; i++) {
      const subjects = postList[i]?.subjects || [];

      for (let j = 0; j < subjects.length; j++) {
        const configs = subjects[j]?.examSubjectConfig || [];

        const found = configs.find(
          (item) => String(item.questionSet).toUpperCase() === String(setLabel).toUpperCase()
        );

        if (found) {
          count = Number(found.totalQuestions);
          break;
        }
      }
      if (count > 0) break;
    }


    if (count > 0) {
      generateRows(count);
    } else {
      console.warn("No totalQuestions found in resultFlowInfo for set:", setLabel);
    }
  };

  const generateRows = (count) => {
    let arrayData = [];

    for (let i = 0; i < count; i++) {
      let optionArray = [];

      answerKeySetList &&
        answerKeySetList.length > 0 &&
        answerKeySetList.map((elle, ind) => {
          let obbj = {
            option: elle.val,
            marks: 0,
            negativeMarks: 0,
            isHidden: true,
          };
          if (ind == 0) obbj.isHidden = false;
          optionArray.push(obbj);
        });

      arrayData.push({
        questionNumber: i + 1,
        isWeighted: false,
        answers: optionArray,
      });
    }

    setRulesDataList(arrayData);
    setReloadItem(!reloadItem);
  };

  const onChangeExam = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    dispatch(getObjectiveStatusflag(selectedValue, setSaveButtonFlag));
    if (answerKeyDataList.answers) {
      answerKeyDataList.answers.length = 0;
    }
    rulesCalculateResultData = "";
    setSaveButtonFlag(true);
    setShowCalculateMarks(false);

    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));

    if (stepName == "marksCalculation" && selectedValue !== "") {

      dispatch({
        type: SET_OBJECTIVE_STATUS_DATA,
        payload: {}
      });
      dispatch(getObjectiveStatus(selectedValue));
    }

    // setRequestData([]);
    setReloadItem(!reloadItem);
  };

  const onMarksCalculationSubjectChange = (ele) => {
    let selectedValue = ele.target.value;

    setSelectedSubject(selectedValue);
    const selectedSubjectObj = subjectList.find(
      (item) => item.id === Number(selectedValue)
    );

    setSelectedSubjectType(selectedSubjectObj?.type || "");

    dispatch({
      type: SET_RULES_CALCULATE_RESULT_DATA,
      payload: [],
    });
    setShowCalculateMarks(!!selectedValue);
    setShowCalculateMarks(true);
    setIsMarkCalculated(false);

    if (selectedExam && selectedValue) {
      dispatch(
        getObjectiveStatusflag(
          selectedExam,
          setSaveButtonFlag,
          selectedValue
        )
      );

      dispatch(getObjectiveStatus(selectedExam, selectedValue));
    }

    setRequestData([]);
    setReloadItem((prev) => !prev);
  };
  const handleCalculate = () => {
    if (stepName === "marksCalculation") {
      setActiveButton("calculate");

      dispatch({
        type: "SET_VIEW_RESULT_DATA",
        payload: [],
      });

      dispatch(getRulesCalculatedResult(selectedExam, selectedSubject));

      setIsMarkCalculated(true);
    }
  };

  const onhandleViewMarks = () => {
    if (stepName === "marksCalculation") {
      setActiveButton("view");

      dispatch({
        type: SET_RULES_CALCULATE_RESULT_DATA,
        payload: [],
      });

      dispatch(getViewResult(selectedExam));
    }
  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;

    setSelectedAdvertisement(selectedValue);

    setSelectedExam("");

    examList.length = 0;
    subjectList.length = 0;
    questionSetList.length = 0;

    rulesCalculateResultData = "";

    if (answerKeyDataList.answers) {
      answerKeyDataList.answers.length = 0;
    }

    selectedValue &&
      dispatch(getExamslistByAdvertisementId(selectedValue));

    setRequestData([]);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };
  const onChangeIsWeighted = (e, indd) => {
    let checkedVal = e.target.checked;

    let newRequestData = rulesDataList;
    rulesDataList &&
      rulesDataList.length > 0 &&
      rulesDataList.map((elle, ind) => {
        if (elle.questionNumber == indd) {
          if (checkedVal) {
            newRequestData[ind].isWeighted = checkedVal;
            if (rulesDataList[ind].answers.length > 0) {
              rulesDataList[ind].answers &&
                rulesDataList[ind].answers.length > 0 &&
                rulesDataList[ind].answers.map((opt, optInd) => {
                  newRequestData[ind].answers[optInd].isHidden = false;
                });

              setRulesDataList(newRequestData);
              setReloadItem(!reloadItem);
            }
          } else {
            newRequestData[ind].isWeighted = checkedVal;
            rulesDataList[ind].answers &&
              rulesDataList[ind].answers.length > 0 &&
              rulesDataList[ind].answers.map((opt, optInd) => {
                if (optInd == 0) {
                  newRequestData[ind].answers[optInd].isHidden = false;
                } else {
                  newRequestData[ind].answers[optInd].isHidden = true;
                }
              });
            setRulesDataList(newRequestData);
            setReloadItem(!reloadItem);
          }
        }
      });

    setSaveButtonFlag(false);
  };

  const addAnswerData = (e, questionNumber, answerOption, typeOfValue) => {
    let newRequestData = rulesDataList;
    rulesDataList &&
      rulesDataList.length > 0 &&
      rulesDataList.map((elle, innd) => {
        if (elle.questionNumber == questionNumber) {
          elle &&
            elle.answers &&
            elle.answers.length > 0 &&
            elle.answers.map((ellm, indx) => {
              if (ellm.option == answerOption) {
                if (typeOfValue == 1) {
                  newRequestData[innd].answers[indx].marks = e.target.value;
                } else if (typeOfValue == 2) {
                  newRequestData[innd].answers[indx].negativeMarks =
                    e.target.value;
                }
              }
            });
          setRulesDataList(newRequestData);
          setReloadItem(!reloadItem);
        }
      });

    setSaveButtonFlag(false);
  };

  const optionNameChange = (e, questionNumber, index) => {
    let selectVal = e.target.value;
    let newRequestData = rulesDataList;
    rulesDataList &&
      rulesDataList.length > 0 &&
      rulesDataList.map((elle, innd) => {
        if (elle.questionNumber == questionNumber) {
          let oldindex = "";
          elle &&
            elle.answers &&
            elle.answers.length > 0 &&
            elle.answers.map((ellm, indx) => {
              if (selectVal == ellm.option) {
                oldindex = indx;
              }
              if (oldindex != "" && indx == elle.answers.length - 1) {
                let oldOption = newRequestData[innd].answers[index].option;
                newRequestData[innd].answers[index].option = selectVal;
                newRequestData[innd].answers[oldindex].option = oldOption;
              }
            });
          setRulesDataList(newRequestData);
          setReloadItem(!reloadItem);
        }
      });

    setSaveButtonFlag(false);
  };

  const generatePdfFileName = () => {
    if (
      viewMarksList &&
      viewMarksList.candidates &&
      viewMarksList.candidates.length > 0
    ) {
      return "View Marks.pdf";
    } else {
      return "Marks Calculation.pdf";
    }
  };

  const genPdf = () => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = `
    <div class="row d-flex flex-column align-items-center">
      <h5 class="bold-label">${commonLabels.MPSC}</h5>
      <h5>${rulesCalculateResultData?.examName || viewMarksList?.examName || ""
      }</h5>
      <h5>${commonLabels.MarksCandidateAppliedForVerification}</h5>
    </div>`;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: generatePdfFileName(),
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY);

          const ad =
            rulesCalculateResultData?.advertisementNo ||
            viewMarksList?.advertisementNo ||
            "";
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(generatePdfFileName());
      });
  };

  const forAllAddAnswerData = (e) => {
    setForAllMarks(e.target.value);
  };

  const forallNegativeMarks = (e) => {
    setForAllNegativeMarks(e.target.value);
  };

  const generateMarksCalculationPdfData = () => {
    genPdf();
    // dispatch(generateMarksCalculationPdf(selectedExam));
  };
  const handleReset = () => {
    // reset();
  }
  const onhandleUnlock = (status, lock) => {
    dispatch(
      objetiveStatusLockUnlock(
        selectedExam,
        status,
        lock,
        selectedSubject,
        handleReset
      )
    );
    setReloadItem(!reloadItem);
  };
  const onCancelMarksCalculation = () => {
    setAddYear("");
    setSelectedAdvertisement("");
    setSelectedExam("");
    setSelectedSubject("");
    setActiveButton("");
    setIsMarkCalculated(false);
    setShowCalculateMarks(false);

    if (allYearList) allYearList.length = 0;
    if (examList) examList.length = 0;
    if (subjectList) subjectList.length = 0;
    if (questionSetList) questionSetList.length = 0;

    dispatch({
      type: SET_RULES_CALCULATE_RESULT_DATA,
      payload: [],
    });

    dispatch({
      type: "SET_VIEW_RESULT_DATA",
      payload: [],
    });

    dispatch({
      type: SET_OBJECTIVE_STATUS_DATA,
      payload: {},
    });

    setReloadItem(!reloadItem);

  };
  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.ObjectiveMarksCalculation} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "addrule"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="addrule"
              id="addrule-tab"
              onClick={() => setName("addrule")}
              data-toggle="tab"
              role="tab"
              aria-controls="addrule"
              aria-selected="false"
            >
              <span>{label.addRules}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "unapproved"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="unapproved"
              id="unapproved-tab"
              onClick={() => setName("unapproved")}
              data-toggle="tab"
              role="tab"
              aria-controls="unapproved"
              aria-selected="false"
            >
              <span>{label.rulesList}</span>
            </a>
          </li>
          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "marksCalculation"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="marksCalculation"
              id="marksCalculation-tab"
              onClick={() => setName("marksCalculation")}
              data-toggle="tab"
              role="tab"
              aria-controls="marksCalculation"
              aria-selected="false"
            >
              <span>{label.marksCalculation}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "addrule"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="addrule"
            role="tabpanel"
            aria-labelledby="addrule-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          value={selectedYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                              // <option key={index} value={element.id}>
                              //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                              // </option>
                            ))}
                        </select>
                        {_.get("selectedYear.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index + 1} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectSubject}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedSubject"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onSubjectChange(e);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {subjectList &&
                            subjectList.length > 0 &&
                            subjectList
                              // .filter(
                              //   (element) =>
                              //     element.isDeleted === false &&
                              //     element.isActive === true
                              // )
                              .map((element, index) => (
                                <option key={index + 1} value={element.id}>
                                  {element.name}({element.type?.toUpperCase()})
                                </option>
                              ))}
                        </select>
                        {_.get("selectedSubject.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.questionSet}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedQuestionSet"
                          // ref={register({ required: true })}
                          value={selectedQuestionSet}
                          onChange={(e) => onQuestionSetChange(e)}
                        >
                          <option disabled value="">
                            Select
                          </option>
                          {questionSetList &&
                            questionSetList.length > 0 &&
                            questionSetList.map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                        </select>
                        {_.get("selectedSubject.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="row pl-3 pr-3">
                      {flagArray &&
                        flagArray
                          .filter((ele) => {
                            if (ele.flag === "Marks Criteria") {
                              return ele.flagStatus === true;
                            }
                            return true;
                          })
                          .map((ele, index) => (
                            <div className="d-flex p-2" key={index}>
                              <input
                                type="checkbox"
                                disabled
                                checked={ele.flagStatus}
                                className="form-control"
                              />
                              <label className="ml-1">{ele.flag}</label>
                            </div>
                          ))}
                    </div>
                    {((answerKeyDataList &&
                      answerKeyDataList.answerKeyRuleDto?.answerKey != null) ||
                      (answerKeyDataList &&
                        answerKeyDataList.answerKeyRuleDto?.answerKeyRule != null)) && (
                        <div className="row">
                          {rulesDataList.length > 0 ? (
                            <div className="col-md-12">
                              <div className="table-responsive">
                                <table className="table table-bordered text-center">
                                  <thead
                                    style={{
                                      backgroundColor: "#f1f5f9",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ width: "8%" }}>
                                        {label.QUESTION_NO}
                                      </th>

                                      <th style={{ width: "10%" }}>
                                        {label.isWeighted}
                                      </th>

                                      <th style={{ width: "27%" }}>
                                        {label.answerOptions}
                                      </th>

                                      <th style={{ width: "27%" }}>
                                        <div className="font-weight-bold mb-1">
                                          {label.answerMarks}
                                        </div>

                                        <input
                                          type="text"
                                          className="form-control"
                                          value={forAllMarks}
                                          onChange={(e) =>
                                            forAllAddAnswerData(e)
                                          }
                                          placeholder="For All"
                                        />
                                      </th>

                                      <th style={{ width: "28%" }}>
                                        <div className="font-weight-bold mb-1">
                                          {label.answerNegMarks}
                                        </div>

                                        <input
                                          type="text"
                                          className="form-control"
                                          value={forAllNegativeMarks}
                                          onChange={(e) =>
                                            forallNegativeMarks(e)
                                          }
                                          placeholder="For All"
                                        />
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {rulesDataList.map((ele, index) => (
                                      <tr key={index}>
                                        {/* Question No */}
                                        <td className="align-middle font-weight-bold">
                                          {ele.questionNumber}
                                        </td>

                                        {/* Weighted */}
                                        <td className="align-middle">
                                          <input
                                            type="checkbox"
                                            checked={
                                              ele.isWeighted
                                                ? true
                                                : false
                                            }
                                            onChange={(e) =>
                                              onChangeIsWeighted(
                                                e,
                                                ele.questionNumber
                                              )
                                            }
                                          />
                                        </td>

                                        {/* Answer Options */}
                                        <td className="p-2">
                                          {ele.answers &&
                                            ele.answers.map(
                                              (ell, ind) => {
                                                if (
                                                  ell.isHidden !== true
                                                ) {
                                                  return (
                                                    <div
                                                      key={ind}
                                                      className="mb-2"
                                                    >
                                                      <select
                                                        className="form-control"
                                                        defaultValue={
                                                          ell.option
                                                        }
                                                        onChange={(
                                                          e
                                                        ) =>
                                                          optionNameChange(
                                                            e,
                                                            ele.questionNumber,
                                                            ind
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          {
                                                            commonLabels.COMBO_SELECT
                                                          }
                                                        </option>

                                                        {answerKeySetList &&
                                                          answerKeySetList.map(
                                                            (
                                                              opt,
                                                              i
                                                            ) => {
                                                              if (
                                                                ele.isWeighted ==
                                                                false
                                                              ) {
                                                                return (
                                                                  <option
                                                                    key={
                                                                      i
                                                                    }
                                                                    value={
                                                                      opt.val
                                                                    }
                                                                  >
                                                                    {
                                                                      opt.label
                                                                    }
                                                                  </option>
                                                                );
                                                              } else {
                                                                if (
                                                                  opt.val !=
                                                                  "g"
                                                                ) {
                                                                  return (
                                                                    <option
                                                                      key={
                                                                        i
                                                                      }
                                                                      value={
                                                                        opt.val
                                                                      }
                                                                    >
                                                                      {
                                                                        opt.label
                                                                      }
                                                                    </option>
                                                                  );
                                                                }
                                                              }
                                                            }
                                                          )}
                                                      </select>
                                                    </div>
                                                  );
                                                }
                                              }
                                            )}
                                        </td>

                                        {/* Answer Marks */}
                                        <td className="p-2">
                                          {ele.answers &&
                                            ele.answers.map(
                                              (ell, ind) => {
                                                if (
                                                  ell.isHidden !== true
                                                ) {
                                                  return (
                                                    <div
                                                      key={ind}
                                                      className="mb-2"
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          ell.marks
                                                        }
                                                        onChange={(
                                                          e
                                                        ) =>
                                                          addAnswerData(
                                                            e,
                                                            ele.questionNumber,
                                                            ell.option,
                                                            1
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  );
                                                }
                                              }
                                            )}
                                        </td>

                                        {/* Negative Marks */}
                                        <td className="p-2">
                                          {ele.answers &&
                                            ele.answers.map(
                                              (ell, ind) => {
                                                if (
                                                  ell.isHidden !== true
                                                ) {
                                                  return (
                                                    <div
                                                      key={ind}
                                                      className="mb-2"
                                                    >
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          ell.negativeMarks
                                                        }
                                                        onChange={(
                                                          e
                                                        ) =>
                                                          addAnswerData(
                                                            e,
                                                            ele.questionNumber,
                                                            ell.option,
                                                            2
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  );
                                                }
                                              }
                                            )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    <div className="row">
                      <div className="form-group col-md-6">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>

                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={saveButtonFlag}
                          onClick={(e) => {
                            onSubmit();
                          }}
                        >
                          {commonLabels.BUTTON_SAVE}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "unapproved"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="unapproved"
            role="tabpanel"
            aria-labelledby="unapproved-tab"
          >
            {allUnapprovalRulesList &&
              allUnapprovalRulesList.entityApprovalDtoList &&
              allUnapprovalRulesList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th
                            key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}
                          >
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allUnapprovalRulesList &&
                      allUnapprovalRulesList.entityApprovalDtoList &&
                      allUnapprovalRulesList.entityApprovalDtoList.length > 0 &&
                      allUnapprovalRulesList.entityApprovalDtoList.map(
                        (ele, index) => {
                          const detail =
                            typeof ele.entityApprovalAction.entityApprovalDto.detail === "string"
                              ? JSON.parse(ele.entityApprovalAction.entityApprovalDto.detail)
                              : ele.entityApprovalAction.entityApprovalDto.detail;

                          const ruleDetail = detail?.answerKeyRule || detail;
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className=" word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>

                              <td className="w-10 word-break width-20">
                                {ruleDetail?.exam?.name}
                                <br />
                                {ruleDetail?.exam?.nameDvng}
                              </td>

                              <td className="w-10 word-break width-12">
                                {ruleDetail?.subject?.name}
                                <br />
                                {ruleDetail?.subject?.nameDvng}
                              </td>

                              <td>
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className=" word-break">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center">
                                {console.log("set", ele?.entityApprovalAction?.entityApprovalDto?.selectedSet?.label)}
                                {
                                  ele?.entityApprovalAction?.entityApprovalDto?.selectedSet?.label
                                }
                              </td>
                              <td className="text-center word-break width-12">
                                {(session.roleName == "superadmin" || session.isSuperAdmin == true ||
                                  session.roleName == "desk officer") && (
                                    <button
                                      type="button"
                                      className="pull-right btn btn-outline-primary btn-sm custom-button"
                                      onClick={() => {
                                        handleApprovalUser(ele);
                                      }}
                                    >
                                      {label.REVIEW}
                                    </button>
                                  )}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_rules_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={allUnapprovalRulesList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "marksCalculation"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="marksCalculation"
            role="tabpanel"
            aria-labelledby="marksCalculation-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row custom-row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear1"
                          value={addYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                              // <option key={index} value={element.id}>
                              //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                              // </option>
                            ))}
                        </select>
                        {_.get("selectedYear1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo1.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onChangeExam(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index + 1} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col">
                        <label className="float-left">
                          {label.SelectSubject}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedSubject1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onMarksCalculationSubjectChange(e);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {subjectList &&
                            subjectList.length > 0 &&
                            subjectList
                              // .filter(
                              //   (element) =>
                              //     element.isDeleted === false &&
                              //     element.isActive === true
                              // )
                              .map((element, index) => (
                                <option key={index + 1} value={element.id}>
                                  {element.name}({element.type?.toUpperCase()})
                                </option>
                              ))}
                        </select>
                        {_.get("selectedSubject1.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="row pl-2 pr-3">
                      {flagArray1 &&
                        flagArray1
                          .filter((ele) => {
                            if (ele.flag === "Marks Criteria") {
                              return ele.flagStatus === true;
                            }
                            if (ele.flag === "Result") {
                              return ele.flagStatus === true;
                            }
                            return true;
                          })
                          .map((ele, index) => (
                            <div className="d-flex p-2" key={index}>
                              <input
                                type="checkbox"
                                disabled
                                checked={ele.flagStatus}
                                className="form-control"
                              />
                              <label className="ml-1">{ele.flag}</label>
                            </div>
                          ))}
                      {selectedExam && (
                        <div className="d-flex p-2">
                          <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={onCancelMarksCalculation}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className=" btn btn-primary"
                            onClick={onhandleViewMarks}
                            disabled={activeButton === "calculate"}
                          >
                            {label.ViewMarks}
                          </button>
                          {selectedExam && selectedSubject && (
                            <button
                              type="button"
                              className="btn btn-primary ml-2"
                              onClick={handleCalculate}
                              disabled={activeButton === "view"}

                            >
                              {label.CalculateMarks}
                            </button>
                          )}
                          {session.roleName == "superadmin" &&
                            (
                              <button
                                type="button"
                                className={`btn ml-2 ${processLockState.result
                                  ? "btn-lock-green"
                                  : "btn-unlock-red"
                                  }`}
                                style={{
                                  borderRadius: "0.60rem",
                                }}
                                // disabled={!isMarkCalculated}
                                disabled={!processLockState.result && !isMarkCalculated}
                                onClick={() => {
                                  const newState = !processLockState.result;

                                  dispatch({
                                    type: SET_PROCESS_LOCK_STATE,
                                    payload: {
                                      ...processLockState,
                                      result: newState,
                                    },
                                  });

                                  onhandleUnlock("resultgenerated", newState);
                                }}
                              >
                                {console.log("processLockState", processLockState)}
                                {processLockState.result
                                  ? commonLabels.BUTTON_UNLOCK
                                  : commonLabels.BUTTON_LOCK}
                              </button>
                            )}
                        </div>
                      )}
                    </div>

                    {rulesCalculateResultData &&
                      rulesCalculateResultData.candidates &&
                      rulesCalculateResultData.candidates.length > 0 && (
                        <>
                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <div className="row">
                                <div className="col-md-12">
                                  <button
                                    type="button"
                                    name="pdfPrint"
                                    className="btn btn-primary float-right"
                                    onClick={() => {
                                      generateMarksCalculationPdfData();
                                    }}
                                  >
                                    {commonLabels.BUTTON_PRINT}
                                  </button>
                                </div>
                              </div>
                            )}
                          <div id="marksCalculationData">
                            {(rulesCalculateResultData?.candidates?.length > 0 ||
                              viewMarksList?.candidates?.length > 0) && (
                                <>
                                  <div className="row"></div>
                                  <div className="row">
                                    <div className="col-md-12" ref={pdfRef}>
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr className="border-dark border-top border-3">
                                            <th rowSpan={2} className="text-center">
                                              {commonLabels.SrNo}
                                            </th>

                                            <th rowSpan={2} className="text-center">
                                              {label.ROLL_NO}
                                            </th>

                                            <th rowSpan={2}>
                                              {label.CandidateName}
                                            </th>

                                            <th colSpan={8} className="text-center bg-gray">
                                              {label.MARKS}
                                            </th>
                                          </tr>

                                          <tr className="border-dark border-bottom border-3">
                                            {rulesCalculateResultData?.candidates?.length > 0 &&
                                              rulesCalculateResultData.candidates[0]?.subjects?.map(
                                                (sub, indd) => (
                                                  <th key={indd}>{sub.name}</th>
                                                )
                                              )}

                                            <th>{label.totalMarks}</th>
                                          </tr>
                                        </thead>

                                        <tbody className="table-font-12">
                                          {rulesCalculateResultData?.candidates?.length > 0 &&
                                            rulesCalculateResultData.candidates.map((item, ind) => (
                                              <tr
                                                key={ind}
                                                className="border-dark border-bottom"
                                              >
                                                <td className="text-center">{ind + 1}</td>
                                                <td>{item.rollNo}</td>
                                                <td>{item.candidateName}</td>

                                                {item?.subjects?.map((sub, indd) => (
                                                  <td key={indd}>{sub.marks}</td>
                                                ))}

                                                <td>{item.totalMarks}</td>
                                              </tr>
                                            ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                          </div>
                        </>
                      )}

                    {viewMarksList &&
                      viewMarksList.candidates &&
                      viewMarksList.candidates.length > 0 && (
                        <>
                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <div className="row">
                                <div className="col-md-12">
                                  <button
                                    type="button"
                                    name="pdfPrint"
                                    className="btn btn-primary float-right"
                                    onClick={() => {
                                      generateMarksCalculationPdfData();
                                    }}
                                  >
                                    {commonLabels.BUTTON_PRINT}
                                  </button>
                                </div>
                              </div>
                            )}
                          <div id="marksCalculationData">

                            {(viewMarksList?.candidates?.length > 0 ||
                              rulesCalculateResultData?.candidates?.length > 0) && (

                                <>
                                  <div className="row"></div>

                                  <div className="row">
                                    <div className="col-md-12" ref={pdfRef}>
                                      <table className="table table-bordered">

                                        <thead>
                                          <tr className="border-dark border-top border-3">
                                            <th rowSpan={2} className="text-center">
                                              {commonLabels.SrNo}
                                            </th>

                                            <th rowSpan={2} className="text-center">
                                              {label.ROLL_NO}
                                            </th>

                                            <th rowSpan={2}>
                                              {label.CandidateName}
                                            </th>

                                            <th colSpan={8} className="text-center bg-gray">
                                              {label.MARKS}
                                            </th>
                                          </tr>

                                          <tr className="border-dark border-bottom border-3">
                                            {viewMarksList?.candidates?.length > 0 &&
                                              viewMarksList.candidates[0]?.subjects?.map(
                                                (sub, indd) => (
                                                  <th key={indd}>{sub.name}</th>
                                                )
                                              )}

                                            <th className="text-right">
                                              {label.totalMarks}
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody className="table-font-12">
                                          {viewMarksList?.candidates?.length > 0 &&
                                            viewMarksList.candidates.map((item, ind) => (
                                              <tr
                                                key={ind}
                                                className="border-dark border-bottom"
                                              >
                                                <td className="text-center">{ind + 1}</td>

                                                <td className="text-center">
                                                  {item.rollNo}
                                                </td>

                                                <td>{item.candidateName}</td>

                                                {item?.subjects?.map((sub, indd) => (
                                                  <td key={indd}>{sub.marks}</td>
                                                ))}

                                                <td className="text-right">
                                                  {item.totalMarks}
                                                </td>
                                              </tr>
                                            ))}
                                        </tbody>

                                      </table>
                                    </div>
                                  </div>
                                </>
                              )}
                          </div>
                        </>
                      )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {approvalEntityModal && (
          <ApprovalRuleEntity
            showModal={approvalEntityModal}
            setShowModal={setApprovalEntityModal}
            setSelectedApprovalEntity={selectedApprovalEntity}
          />
        )}
      </div>
    </div>
  );
};

export default ObjectiveMarksCalculation;
